// extracted by mini-css-extract-plugin
module.exports = {"header":"style_header__+l8il"};